
var drawer = function () {
    if (!Element.prototype.closest) {
      if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
      }
      Element.prototype.closest = function (s) {
        var el = this;
        var ancestor = this;
        if (!document.documentElement.contains(el)) return null;
        do {
          if (ancestor.matches(s)) return ancestor;
          ancestor = ancestor.parentElement;
        } while (ancestor !== null);
        return null;
      };
    }
    //
    // Settings
    //
    var settings = {
      speedOpen: 50,
      speedClose: 350,
      timeOpen:15000,
      activeClass: 'is-active',
      visibleClass: 'is-visible',
      selectorTarget: '[data-drawer-target]',
      selectorTrigger: '[data-drawer-trigger]',
      selectorClose: '[data-drawer-close]',
    };

    //
    // Methods
    async function drawProduct(product) {
      const res = await fetch('/cart.js')
      const data = await res.json()
      const productPrice = document.querySelector('.price-item.price-item--regular').innerText
      $.get('/cart?view=mini', function(pdata) {
        $('#cart__drawer').html($(pdata).find('#cart__drawer').html());
        var text = ((data.items_subtotal_price / 100) > 175) ? 'FREE Shipping unlocked!' : 'FREE Shipping Above $175';
        var get_price = data.items_subtotal_price / 100;
        if (get_price == 0){
           $('.ship_text').html('FREE Shipping Above $175');
        } else if (get_price > 175){
           $('.ship_text').html('FREE Shipping unlocked!');
        } else {
          var get_price =  175 - get_price;
          var get_price =  get_price.toFixed(2);
          $('.ship_text').html('$' + get_price + ' to Unlock Free Shipping');
        }
       
        const progressSize = ((data.items_subtotal_price / 100) > 175) ? 100 : (data.items_subtotal_price / 175)
        const progress = document.querySelectorAll('.progress')
        progress.forEach((el) => {
          el.style.width = `${progressSize}%`
        })
      });
    }
    //
    // Toggle accessibility
    var toggleccessibility = function (event) {
      
      if (event.getAttribute('aria-expanded') === 'true') {
        event.setAttribute('aria-expanded', false);
      } else {
        event.setAttribute('aria-expanded', true);
      }
    };
    // Open Drawer
    var openDrawer = async function (trigger) {
      await drawProduct(globalThis.lastProduct)
      // Find target
      var target = document.getElementById(trigger.getAttribute('aria-controls'));
      // Make it active
      target.classList.add(settings.activeClass);
      // Make body overflow hidden so it's not scrollable
      // document.documentElement.style.overflow = 'hidden';
      // Toggle accessibility
      toggleccessibility(trigger);
      // Make it visible
      setTimeout(function () {
        target.classList.add(settings.visibleClass);
      }, settings.speedOpen);
      setTimeout(function () {
        if (document.querySelector(".drawer__close")) {
          closeDrawer(document.querySelector(".drawer__close"));
        }
      }, settings.timeOpen);
    };
    // Close Drawer
    var closeDrawer = function (event) {
      // Find target
      var closestParent = event.closest(settings.selectorTarget),
        childrenTrigger = document.querySelector('[aria-controls="' + closestParent.id + '"');
      // Make it not visible
      closestParent.classList.remove(settings.visibleClass);
      // Remove body overflow hidden
      document.documentElement.style.overflow = '';
      // Toggle accessibility
      toggleccessibility(childrenTrigger);
      // Make it not active
      setTimeout(function () {
        closestParent.classList.remove(settings.activeClass);
      }, settings.speedClose);
    };
    // Click Handler
    var clickHandler = function (event) {
      // Find elements

      var toggle = event.target,
        open = toggle.closest(settings.selectorTrigger),
        close = toggle.closest(settings.selectorClose);
      // Open drawer when the open button is clicked
      if (open) {
        openDrawer(open);
      }
      // Close drawer when the close button (or overlay area) is clicked
      if (close) {
        closeDrawer(close);
      }
      // Prevent default link behavior
      if (open || close) {
        event.preventDefault();
      }
    };
    // Keydown Handler, handle Escape button
    var keydownHandler = function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        // Find all possible drawers
        var drawers = document.querySelectorAll(settings.selectorTarget),
          i;
        // Find active drawers and close them when escape is clicked
        for (i = 0; i < drawers.length; ++i) {
          if (drawers[i].classList.contains(settings.activeClass)) {
            closeDrawer(drawers[i]);
          }
        }
      }
    };

    //
    // Inits & Event Listeners
    //
    document.addEventListener('click', clickHandler, false);
    document.addEventListener('keydown', keydownHandler, false);

};
drawer();

$(document).ready(function() {
  $('body').on('click', '.remove_item', function(e) {
    e.preventDefault();
    var id = $(this).attr('data-id');
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']=0',
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
      }
    }).done(function( data ) {
      async function updrawProduct(product) {
        const res = await fetch('/cart.js')
        const data = await res.json()
        const productPrice = document.querySelector('.price-item.price-item--regular').innerText
        $.get('/cart?view=mini', function(pdata) {
          $('#cart__drawer').html($(pdata).find('#cart__drawer').html());
          var text = ((data.items_subtotal_price / 100) > 175) ? 'FREE Shipping unlocked!' : 'FREE Shipping Above $175';
          var get_price = data.items_subtotal_price / 100;
          if (get_price == 0){
              $('.ship_text').html('FREE Shipping Above $175');
          } else if (get_price > 175){
             $('.ship_text').html('FREE Shipping unlocked!');
          } else {
            var get_price =  175 - get_price;
            var get_price =  get_price.toFixed(2);
            $('.ship_text').html('$' + get_price + ' to Unlock Free Shipping');
          }
          const progressSize = ((data.items_subtotal_price / 100) > 175) ? 100 : (data.items_subtotal_price / 175)
          const progress = document.querySelectorAll('.progress')
          progress.forEach((el) => {
            el.style.width = `${progressSize}%`
          })
        });
      }
      var update = async function() {
        await updrawProduct(globalThis.lastProduct)
      }
      update();
    });
  });
});
